import { useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import Heading from 'LuxKit/Typography/Heading'

interface Props {
  offer: App.BundleOffer
}

function BundleOfferLocation(props: Props) {
  const bundledOffers = useMemo(() => Object.values(props.offer.bundledOffers), [props.offer.bundledOffers])

  const offerPropertiesTitle = useMemo(
    () => props.offer.location || bundledOffers.map(offer => offer.property.name).join(' + '),
    [props.offer.location, bundledOffers])

  return (
    <Heading as="span" variant="heading6">
      <FormattedMessage
        id="CxerhK1RZXf2y2QcgW6n"
        defaultMessage="<highlight>Bundle & Save:</highlight> {title}"
        
        values={{
          highlight: (chunks) => <Heading as="span" variant="heading6" colour="highlight-primary-dark">{chunks}</Heading>,
          title: offerPropertiesTitle,
        }}
      />
    </Heading>
  )
}

export default BundleOfferLocation
